import { render, staticRenderFns } from "./gj-creator-select.vue?vue&type=template&id=477264f5&scoped=true&"
import script from "./gj-creator-select.vue?vue&type=script&lang=js&"
export * from "./gj-creator-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477264f5",
  null
  
)

export default component.exports